import { cn } from "@/lib/utils"

import { BrandMark } from "./brand-mark"

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand-lockup">
      <BrandMark className="size-10" />
      <span
        className={cn("brand-wordmark", compact && "hidden sm:inline-flex")}
      >
        Groundline
      </span>
    </span>
  )
}
